import {Box} from "@mui/material";
import React from "react";

interface TabNavigatorProps {
  activeTab: string;
  onClickTab: (tabValue: string) => void;
  tabs: {label: string; value: string}[];
}

export const TabNavigator = ({ activeTab, onClickTab, tabs }: TabNavigatorProps) => (
  <Box className="flex bg-white shadow-sm border-b px-2 pt-2">
    {tabs.map(tab => (
      <button
        className={`
          flex-1 text-center py-2 text-sm font-semibold
          ${activeTab === tab.value
            ? 'border-b-2 border-ptTeal text-ptTeal'
            : 'text-gray-500'}
        `}
        onClick={() => onClickTab(tab.value)}
      >
        {tab.label}
      </button>
    ))}
  </Box>
)
